import { Fragment, useEffect, useState } from 'react';
import { KioskAttractorsResponse } from '../types';

type Props = {
  currentAttractors: KioskAttractorsResponse[] | { imageUrl: string }[];
  blobIsVideo?: boolean;
};

const AttractorDisplay = ({
  currentAttractors,
  blobIsVideo = false,
}: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to check if the URL is a video or an image
  const isVideo = (url: string) => {
    if (blobIsVideo) {
      return true;
    }

    return (
      url.endsWith('.mp4') || url.endsWith('.webm') || url.endsWith('.ogg')
    );
  };

  useEffect(() => {
    if (currentAttractors.length > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === currentAttractors.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000); // Change asset every 3 seconds

      return () => clearInterval(intervalId); // Clean up on component unmount
    }
  }, [currentAttractors]);

  // Check if currentAttractors is defined and has items
  if (!currentAttractors || currentAttractors.length === 0) {
    return <div></div>;
  }

  const currentAttractor = currentAttractors[currentIndex];

  // Check if currentAttractor is defined
  if (!currentAttractor || !currentAttractor.imageUrl) {
    return <div></div>;
  }

  console.log(currentAttractor);

  return (
    <Fragment>
      {isVideo(currentAttractor.imageUrl) ? (
        <video
          key={currentAttractor.imageUrl} // Key to force re-render
          src={currentAttractor.imageUrl}
          autoPlay
          muted
          loop
          className="absolute top-[30px] left-[35px] h-[210px] w-[147px] object-cover hidden md:block"
        />
      ) : (
        <img
          src={currentAttractor.imageUrl}
          className="absolute top-[30px] left-[35px] h-[210px] w-[147px] object-cover hidden md:block"
          alt="Attractor"
        />
      )}
    </Fragment>
  );
};

export default AttractorDisplay;
